module.exports = __webpack_public_path__ + "static/media/003tall.2a263562.jpg";